import { useState } from "react";

type InvertibleRateProps = {
  cryptoToFiatRate?: number | null;
  cryptoImage?: string;
  cryptoSymbol?: string;
  fiatImage?: string;
  fiatSymbol?: string;
};

function formatRate(value: number): string {
  return value.toFixed(4);
}

const InvertibleRate = ({
  cryptoToFiatRate,
  cryptoImage,
  cryptoSymbol,
  fiatImage,
  fiatSymbol,
}: InvertibleRateProps) => {
  const [inverted, setInverted] = useState(false);
  const rate = Number(cryptoToFiatRate);
  const hasRate = Number.isFinite(rate) && rate > 0;

  if (!hasRate) {
    return <span className="text-text-base text-[12px] font-normal">- -</span>;
  }

  const leftImage = inverted ? fiatImage : cryptoImage;
  const leftSymbol = inverted ? fiatSymbol : cryptoSymbol;
  const rightImage = inverted ? cryptoImage : fiatImage;
  const rightSymbol = inverted ? cryptoSymbol : fiatSymbol;
  const displayedRate = inverted ? 1 / rate : rate;

  return (
    <button
      type="button"
      onClick={() => setInverted((current) => !current)}
      title="Click to invert rate"
      className="flex flex-row gap-[4px] items-center cursor-pointer rounded-md px-1 py-0.5 -mx-1 hover:bg-bg-page-body transition-colors"
    >
      <span className="text-text-base text-[12px] font-normal">1</span>
      {leftImage && <img src={leftImage} height={12} width={12} alt="" />}
      <span className="text-text-base text-[12px] font-normal">
        {leftSymbol}
      </span>
      <span className="material-symbols-outlined text-[12px] text-icon-base">
        sync_alt
      </span>
      <span className="text-text-base text-[12px] font-normal">
        {formatRate(displayedRate)}
      </span>
      <span className="text-text-base text-[12px] font-normal">
        {rightSymbol}
      </span>
      {rightImage && <img src={rightImage} height={12} width={12} alt="" />}
    </button>
  );
};

export default InvertibleRate;
